export default "__VITE_ASSET__Czemd9kF__"